// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slider_wrapper__1FMqx","index":"Slider_index__fQjrk","line":"Slider_line__3Kac6","total":"Slider_total__2Jm7D"};